import { useEffect, useState } from "react";

export const useTimerState = (time: number = 1000, callbackFn?: () => void) => {
	const [flag, setFlag] = useState<boolean>(false);

	useEffect(() => {
		const tid = globalThis.setTimeout(() => {
			setFlag(true);
			callbackFn?.();
		}, time);

		return () => globalThis.clearTimeout(tid);
	}, []);

	return flag;
};
